'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseAttributes = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _ramda = require('ramda');

var R = _interopRequireWildcard(_ramda);

var _constants = require('./constants');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var parseAttributes = exports.parseAttributes = function parseAttributes(attributes, dimensions, customAttributes) {
  var indexedDimensions = R.indexBy(R.prop('id'), dimensions);
  return R.addIndex(R.map)(function (attr, index) {
    var res = R.assoc('index', index, attr);
    var displayableValuesCount = R.pipe(R.filter(R.propOr(true, 'display')), R.length)(attr);
    if (R.isEmpty(attr.values || []) || !R.propOr(true, 'display', attr) || displayableValuesCount < 1 || attr.id === _constants.REPORTING_YEAR_START_DAY || attr.id === _constants.REPYEARSTART) {
      return R.assoc('display', false, res);
    }
    if (R.propEq('id', customAttributes.prefscale, attr)) {
      return R.assoc('prefscale', true, res);
    }
    if (R.propEq('id', customAttributes.decimals, attr)) {
      return R.assoc('decimals', true, res);
    }
    if (R.hasPath(['relationship', 'none'], attr) || R.hasPath(['relationship', 'dataflow'], attr)) {
      return (0, _extends3.default)({}, res, { header: true, relationship: [] });
    }
    if (R.hasPath(['relationship', 'primaryMeasure'], attr) || R.hasPath(['relationship', 'observation'], attr)) {
      return (0, _extends3.default)({}, res, { series: true, relationship: [] });
    }
    var seriesDimensions = R.pipe(R.pathOr([], ['relationship', 'dimensions']), R.filter(function (id) {
      var dimension = R.prop(id, indexedDimensions);
      return !dimension.header && R.length(dimension.values || []) > 1;
    }))(attr);
    if (R.length(seriesDimensions) > 0) {
      return (0, _extends3.default)({}, res, { series: true, relationship: seriesDimensions });
    }
    return (0, _extends3.default)({}, res, { header: true, relationship: R.prop('dimensions', attr.relationship || []) });
  }, attributes);
};